import { DEFAULT_EXPERIENCE_FILTERS, type IExperienceFilter } from '@/widgets/filtersBlock';

export const getPeriodFilterTitle = (start_date: string, end_date: string, t: (value: string) => string) => {
  const sDate = new Date(start_date);

  let out = `${sDate.getDate()} ${t('month.' + sDate.getMonth())}`;

  if (end_date === '') {
    return out;
  }

  const eDate = new Date(end_date);

  if (sDate.getFullYear() !== eDate.getFullYear()) {
    out += ` ${sDate.getFullYear()}`;
  }

  out += ` — ${eDate.getDate()} ${t('month.' + eDate.getMonth())} ${eDate.getFullYear()}`;

  return out;
};

export const getFiltersDefaultState = (): IExperienceFilter => {
  return JSON.parse(JSON.stringify(DEFAULT_EXPERIENCE_FILTERS));
};
